// hooks/useInvoice.ts
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../store';
import { getBankDetails, generateOTP, saveBankDetails, clearInvoiceData, clearError, clearMessage } from '../features/invoice/invoice.slice';
import { SaveBankDetailsRequest } from '../features/invoice/invoice.service';

export const useInvoice = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { bankDetails, loading, error, message, otpLoading, saveLoading } = useSelector((state: RootState) => state.invoice);

  useEffect(() => {
    if (!bankDetails) {
      dispatch(getBankDetails());
    }
  }, [dispatch, bankDetails]);

  const actions = {
    loadBankDetails: () => dispatch(getBankDetails()),
    generateOTP: (lang: string = 'en') => dispatch(generateOTP(lang)),
    saveBankDetails: (payload: SaveBankDetailsRequest) => dispatch(saveBankDetails(payload)),
    clearData: () => dispatch(clearInvoiceData()),
    clearError: () => dispatch(clearError()),
    clearMessage: () => dispatch(clearMessage()),
  };

  return {
    bankDetails,
    loading,
    error,
    message,
    otpLoading,
    saveLoading,
    ...actions,
  };
};
